import {
  IActionPlanFilter,
  IActionPlanListRequest,
  IActionPlanListType,
} from '../app/@types/actionPlanList';
import { MultiUserLookupLogic } from '../app/@types/myAudit';
import { Event } from '../enums/labels/Event';
import { Nullable } from '../app/@types/genericTypes';
import { ActionPlanListType } from '../enums/ActionPlanListType';

export function convertMultiUserLogicForAP (
  cond?: boolean
): MultiUserLookupLogic {
  if (cond === false) { return 'and'; }
  if (cond === true) { return 'or'; }
  return 'and';
}

export function parseMultiUserLogic (logic: MultiUserLookupLogic): boolean {
  return logic === 'or';
}
export function handleMultiUserLookUpLogicForAP (containsUsers, logic) {
  return containsUsers && containsUsers.length
    ? parseMultiUserLogic(logic)
    : undefined;
}

export function makeActionPlanListFilter (
  filter: IActionPlanFilter,
  actionPlanListType: IActionPlanListType,
  overdue: boolean
): IActionPlanListRequest {
  let searchIds: Nullable<number>[] = [];
  if (filter.selectedUser && filter.selectedUser.length) {
    searchIds = filter.selectedUser.map((user) => user.id);
  }
  if (filter.containsUsers && filter.containsUsers.length) {
    searchIds = searchIds.concat(filter.containsUsers.map((user) => user.id));
  }
  const { selectedUser, containsUsers, listFilterType, ...remainingFilter } =
    filter;
  return {
    ...remainingFilter,
    isSeries:
      actionPlanListType === ActionPlanListType.series ? true : undefined,
    ownerId: filter.listFilterType !== Event.received ? searchIds : undefined,
    assigneeId: filter.listFilterType !== Event.sent ? searchIds : undefined,
    cond: handleMultiUserLookUpLogicForAP(filter.containsUsers, filter.cond),
    overdue: overdue ? overdue : undefined,
  };
}
